export const $ = jQuery;
